export const $ = jQuery;
